"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ObjectForm = _interopRequireDefault(require("@/components/ObjectForm"));
var _user = require("@/api/user/user");
var _validate = require("@/libs/validate1");
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    formIcon: _ObjectForm.default
  },
  data: function data() {
    return {
      formData: {
        rules: {
          adminName: [{
            required: true,
            message: "请输入管理员姓名",
            trigger: "blur"
          }, {
            min: 2,
            max: 15,
            message: "长度在 2 到 15 个字符",
            trigger: "blur"
          }],
          IDCard: [{
            required: true,
            message: "请输入身份证号",
            trigger: "blur"
          }, {
            validator: _validate.validateIdNo,
            trigger: "blur"
          }],
          loginID: [{
            required: true,
            message: "请输入登录账号",
            trigger: "blur"
          }, {
            min: 2,
            max: 16,
            message: "长度在 2 到 16 个字符",
            trigger: "blur"
          }],
          tel: [{
            required: true,
            message: "请输入联系方式",
            trigger: "blur"
          }, {
            validator: _validate.validatePhoneTwo,
            trigger: "blur"
          }],
          email: [{
            required: true,
            message: "请输入邮箱",
            trigger: "blur"
          }, {
            validator: _validate.validateEMail,
            trigger: "blur"
          }]
        },
        labelWidth: "120px",
        inline: false,
        labelPosition: "right",
        size: "small",
        formItem: [{
          type: "input",
          label: "管理员姓名：",
          isDisabled: false,
          placeholder: "请输入管理员姓名",
          prop: "adminName",
          value: "",
          span: 12
        }, {
          type: "input",
          label: "身份证号：",
          isDisabled: false,
          placeholder: "请输入身份证号",
          prop: "IDCard",
          value: "",
          span: 12
        }, {
          type: "input",
          label: "登录账号：",
          isDisabled: false,
          placeholder: "请输入登录账号",
          prop: "loginID",
          value: "",
          span: 12
        }, {
          type: "input",
          label: "手机号：",
          isDisabled: false,
          placeholder: "请输入手机号",
          prop: "tel",
          value: "",
          span: 12
        }, {
          type: "input",
          label: "邮箱：",
          isDisabled: false,
          placeholder: "请输入邮箱",
          prop: "email",
          value: "",
          span: 12
        }]
      }
    };
  },
  methods: {
    submit: function submit(e) {
      var _this = this;
      (0, _user.addUser)({
        provinceId: this.$route.query.id,
        name: e.adminName,
        phoneNumber: e.tel,
        mail: e.email,
        idCard: e.IDCard,
        userType: 1,
        isExpert: 0,
        isPlatUser: 0,
        loginName: e.loginID
      }).then(function (res) {
        if (res.code === 2000) {
          _this.$message.success("操作成功。");
          history.go(-1);
        }
      });
    }
  }
};